import { NavLink, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth.js';
import { Catalog } from './pages/Catalog.js';
import { Login } from './pages/Login.js';
import { Register } from './pages/Register.js';
import { SellerUpload } from './pages/SellerUpload.js';
import { SellerListings } from './pages/SellerListings.js';
import { SellerSales } from './pages/SellerSales.js';
import { Kiosk } from './pages/Kiosk.js';
import { PurchasePending } from './pages/PurchasePending.js';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loading">…</div>;
  if (!user) return <Navigate to="/seller/login" state={{ from: location }} replace />;
  return <>{children}</>;
}

function SellerShell() {
  const { user, logout } = useAuth();
  return (
    <div className="seller-shell">
      <header className="seller-nav">
        <NavLink to="/seller/upload" className={({ isActive }) => (isActive ? 'active' : '')}>
          Upload
        </NavLink>
        <NavLink to="/seller/listings" className={({ isActive }) => (isActive ? 'active' : '')}>
          Listings
        </NavLink>
        <NavLink to="/seller/sales" className={({ isActive }) => (isActive ? 'active' : '')}>
          Sales
        </NavLink>
        <span className="grow" />
        <span className="who">{user?.displayName}</span>
        <button onClick={logout} className="ghost">Log out</button>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Catalog />} />
      <Route path="/pending/:purchaseId" element={<PurchasePending />} />
      <Route path="/kiosk" element={<Kiosk />} />

      <Route path="/seller/login" element={<Login />} />
      <Route path="/seller/register" element={<Register />} />

      <Route
        path="/seller"
        element={
          <RequireAuth>
            <SellerShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="upload" replace />} />
        <Route path="upload" element={<SellerUpload />} />
        <Route path="listings" element={<SellerListings />} />
        <Route path="sales" element={<SellerSales />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
